import React from "react";
import "./loader.styles.css";

export default function Loader() {
  return (
    <div className="loader">
      <h2>Loading...</h2>
    </div>
  );
}
